import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-tarjeta-resumen-cantidad',
  templateUrl: './tarjeta-resumen-cantidad.component.html',
  styleUrl: './tarjeta-resumen-cantidad.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TarjetaResumenCantidadComponent {
  @Input() titulo!: string;
  @Input() cantidad!: number;
  @Input() bgColor!: string;
  @Input() textColor!: string;
  @Input() euros!: boolean;
}
